import {DocumentDtoModel} from './DocumentDto.model';

export class CaseDtoModel {
  identification: string;
  name: string;
  description: string;
  reference: string;
  documents: DocumentDtoModel[];
  teamId: string;
  clientUserId: string;
  creatorUserId: string;
  assigneeUserId: string;
  creationDate: Date;
  released: boolean;

  constructor(data: any) {
    this.identification = data.identification;
    this.name = data.name;
    this.description = data.description;
    this.reference = data.reference;
    if (data.documents == undefined) {
      this.documents = [];
    } else {
      this.documents = data.documents.map((data: any) => new DocumentDtoModel(data));
    }
    this.teamId = data.teamId;
    this.clientUserId = data.clientUserId;
    this.creatorUserId = data.creatorUserId;
    this.assigneeUserId = data.assigneeUserId;
    if (data.creationDate == undefined) {
      this.creationDate = new Date();
    } else {
      this.creationDate = new Date(data.creationDate);
    }
    this.released = data.released ?? false;
  }
}
